import { CancelledError } from '@tanstack/react-query'
import { errors } from '../../services/ruutsApi/errors'

// For a failure out of a React Query read without suppressGlobalError: the API client maps every
// HTTP failure to one of these errors, which the QueryCache bridge has already toasted, and a
// cancellation is not a failure. Anything else was thrown outside the query layer.
export const isReportedByQueryLayer = (error: unknown): boolean =>
  error instanceof CancelledError ||
  error instanceof errors.BusinessEntityError ||
  error instanceof errors.UnexpectedEntityError
